import { LoginModalComponent } from '../login-modal/login-modal.component';
import { DialogService, DynamicDialogRef } from 'primeng/dynamicdialog';
import { Component, OnInit } from '@angular/core';

import { LOGIN_PAGES } from '../../routes/login-process/enum-login-pages';

@Component({
  selector: 'app-timeout-modal',
  templateUrl: './timeout-modal.component.html',
  styleUrls: ['./timeout-modal.component.scss'],
})
export class TimeoutModalComponent implements OnInit {
  constructor(
    public dialogService: DialogService,
    public ref: DynamicDialogRef
  ) {}

  ngOnInit(): void {}

  showLoginModal() {
    this.ref.close();

    this.dialogService.open(LoginModalComponent, {
      data: {
        step: LOGIN_PAGES.EMAIL,
      },
      width: '980px',
      closeOnEscape: false,
    });
  }
}
